import React, { Component } from 'react';

class PlanSelect extends Component {
	state = { isOpen: false, selectedPlan: this.props.value || this.props.defaultValue || '' };

	componentDidMount() {
		document.addEventListener('click', this.handleClickOutside);
		const val = this.state.selectedPlan || (this.props.plans[0] && this.props.plans[0].name) || '';
		if (this.hiddenInputRef && val) {
			this.hiddenInputRef.value = val;
		}
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	}

	componentDidUpdate(prevProps) {
		if (this.props.value !== prevProps.value || this.props.defaultValue !== prevProps.defaultValue) {
			const val = this.props.value || this.props.defaultValue || '';
			if (val !== this.state.selectedPlan) {
				this.setState({ selectedPlan: val });
			}
		}
	}

	handleClickOutside = (e) => {
		if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
			this.setState({ isOpen: false });
		}
	};

	handleSelect = (plan) => {
		this.setState({ selectedPlan: plan, isOpen: false });
		if (this.hiddenInputRef) {
			this.hiddenInputRef.value = plan;
		}
	};

	render() {
		const { plans, name, id } = this.props;
		const { isOpen, selectedPlan } = this.state;
		const displayValue = selectedPlan || (plans[0] && plans[0].name) || '';

		return (
			<div className="fp-plan-select" ref={(el) => (this.wrapperRef = el)}>
				<input type="hidden" name={name} ref={(el) => (this.hiddenInputRef = el)} defaultValue={displayValue} />
				<button
					type="button"
					className={`fp-plan-select-trigger ${isOpen ? 'fp-plan-select-open' : ''}`}
					onClick={() => this.setState({ isOpen: !isOpen })}
					aria-haspopup="listbox"
					aria-expanded={isOpen}
				>
					<span>{displayValue}</span>
					<i className="fa fa-chevron-down" aria-hidden="true" />
				</button>
				{isOpen && (
					<ul className="fp-plan-select-dropdown" role="listbox">
						{plans.map((plan, i) => (
							<li
								key={i}
								role="option"
								className={`fp-plan-select-option ${plan.name === selectedPlan ? 'fp-plan-select-option-selected' : ''}`}
								onClick={() => this.handleSelect(plan.name)}
							>
								{plan.name}
							</li>
						))}
					</ul>
				)}
			</div>
		);
	}
}

export default PlanSelect;
